export const SUGGESTION_STATE_INDICATOR_ONBOARDING_MAX_VIEWS = 3;
export const SUGGESTION_STATE_INDICATOR_ONBOARDING_TOTAL_STEPS = 1;
export const SUGGESTION_STATE_INDICATOR_ONBOARDING_STARTING_STEP = 1;
